import React from 'react';
import { Helmet } from 'react-helmet';

const AboutMe: React.FC = () => (
  <div className="about-container">
    <Helmet>
      <title>About Me | Andrew Sorensen</title>
      <meta name="description" content="Learn about Andrew Sorensen's personal life including his family, passion for landscaping and garden design, and musical background as a jazz saxophonist." />
      <meta name="keywords" content="Andrew Sorensen, About, Family, Philadelphia, Landscaping, Garden Design, Music, Jazz, Saxophone, Personal" />
    </Helmet>
    <div className="about-title-container">
      <h2 className="page-title-about">
        About Me
      </h2>
    </div>
    <div className="about-content-container">
      <div className="about-section">
        <div className="about-section-image-container">
            <img src="/pictures/Family.jpg" alt="Andrew and Wife" className="about-image" />
        </div>
        <div className="about-text-container">
          <h3 className="about-section-title">Family</h3>
          <p className="about-section-content">
            I live in the Philadelphia area with my wife and our two cats.   We enjoy walking our neighborhood and talking with our neighbors, 
            attending local arts communities and festivals, gravel biking, and taking beach trips.   Our favorite places we've travelled are New Orleans, Antigua, 
            and Puerto Vallarta. 
          </p>
        </div>
      </div>
      <div className="about-section about-section-responsive-reverse">
        <div className="about-text-container">
          <h3 className="about-section-title">Landscaping</h3>
          <p className="about-section-content">
            My joy for landscaping and yard maintenance was born out of necessity shortly after my wife and 
            I purchased our first house.  I have an eye for art and design which extends to the lawn and garden.  
            All the gardens on our property I have designed and planted and our lawn is well kept.   
            I appreciate the neighbors stopping to compliment and take pride in improving and maintaining the home.    
          </p>
        </div>
        <div className="about-section-image-container">
            <img src="/pictures/Landscape.jpg" alt="Andrew's Landscaping" className="about-image" />
        </div>
      </div>
      <div className="about-section">
        <div className="about-section-image-container">
            <img src="/pictures/Music.jpg" alt="Andrew Playing Saxophone" className="about-image" />
        </div>
        <div className="about-text-container">
          <h3 className="about-section-title">Musician</h3>
          <p className="about-section-content">
            I've always had a passion for music. In my early years I won entry into regional and state bands.  
            I obtained a college degree in Music Performance (Jazz Saxophone). Now I occasionally get the opportunity 
            to perform as a pit musician for broadway-style musicals for a few weekends of the year as a 
            "woodwind doubler". I play saxophone, flute, clarinet, oboe, and bass guitar, as well as 
            dabbling in other western instruments. I also enjoy unique wind instruments from around the world 
            like the Duduk, Bansuri, Dizi, and Ocarina.    
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default AboutMe;